import { useAppStore } from '../../core/store/store'
export const useTheme = () => {
  const theme = useAppStore((s) => s.ui.theme);
  const isDark = theme === "dark";

  return {
    theme,
    isDark,
    bg: isDark ? "#0b1220" : "#f5f6fb",
    text: isDark ? "#fff" : "#111",
    border: isDark ? "rgba(255,255,255,0.14)" : "rgba(0,0,0,0.08)",
    hover: isDark ? "rgba(255,255,255,0.08)" : "rgba(236, 237, 238, 0.81)",
    glass: isDark ? "rgba(17,24,39,0.65)" : "rgba(255, 255, 255, 1)",
  };
};
